import { required, requiredIf } from 'vuelidate/lib/validators';
import { postcode } from '@/services/Validators/PostcodeValidator';
import { cloneDeep, isEmpty, isUndefined } from 'lodash';
const isUndefinedOrEmpty = value => isUndefined(value) || isEmpty(value);

export const propertyDesignationForm = () => cloneDeep({
  propertyDesignation: {
    label: 'Riskhub Property Designation',
    type: 'text',
    value: '',
  },
  clientPropertyDesignation: {
    label: 'Client Property Designation',
    type: 'text',
    value: '',
  },
})

export const buildingLayoutInformationForm = () => cloneDeep({
  numFloors: {
    label: 'Total no of Floors',
    type: 'text',
    value: '',
  },
  numFloorsCommonArea: {
    label: 'Total no of Floors (common area only)',
    type: 'text',
    value: '',
  },
  numStoreys: {
    label: 'Total no of Storeys (ground and above)',
    type: 'text',
    value: '',
  },
  groundFloorArea: {
    label: 'Ground floor area (m2) (if applicable)',
    type: 'text',
    value: '',
  },
  totalAllFloors: {
    label: 'Total area of all floors (m2) (if applicable)',
    type: 'text',
    value: '',
  },
  buildingLayoutDescription: {
    label: 'Building Layout Description',
    type: 'textarea',
    value: '',
  },
  extentCommonAreas: {
    label: 'Extent of Common areas (describe common areas assessed)',
    type: 'textarea',
    value: '',
  },
  totalNumFlatBesiteBedroom: {
    label: 'Total Number of Flats/Bedsits/Bedrooms (as applicable)',
    type: 'text',
    value: '',
  },
  numFlatsAccessedOfCommonArea: {
    label: 'Number of Flats/Bedsits/Bedrooms accessed off Common Area(s) (if applicable)',
    type: 'text',
    value: '',
  },
  buildingUse: {
    label: 'Building Use',
    type: 'text',
    value: '',
  },
  ancillaryUse: {
    label: 'Ancillary use',
    type: 'textarea',
    value: '',
  },
  numEntranceExit: {
    label: 'Total no of Common Entrances/Exits',
    type: 'text',
    value: '',
  },
  blockAccessibility: {
    label: 'Block Accessibility',
    type: 'text',
    value: '',
  },
  numCommonStaircases: {
    label: 'Total no of Common Staircases',
    type: 'text',
    value: '',
  },
})


export const constructionForm = () => cloneDeep({
  constructionType: {
    label: 'Construction Type',
    type: 'text',
    value: '',
  },
  propertyType: {
    label: 'Property Type',
    type: 'text',
    value: '',
  },
  constructionConversionDate: {
    label: 'Date of Construction or Conversion (year approx.)',
    type: 'text',
    value: '',
  },
  floorConstructionType: {
    label: 'Floor Construction Type',
    type: 'text',
    value: '',
  },
  otherFloorConstruction: {
    label: 'Other Floor Construction Type',
    type: 'text',
    value: '',
  },
  stairConstructionType: {
    label: 'Stair Construction Type',
    type: 'text',
    value: '',
  },
  otherStairConstruction: {
    label: 'Other Stair Construction Type',
    type: 'text',
    value: '',
  },
  externalWallConstructionType: {
    label: 'External Wall Construction Type',
    type: 'text',
    value: '',
  },
  otherExternalWallConstruction: {
    label: 'Other Wall Construction Type',
    type: 'text',
    value: '',
  },
  externalWallFinishType: {
    label: 'External Wall Finish Type',
    type: 'text',
    value: '',
  },
  otherExternalWallFinish: {
    label: 'Other Wall Finish Type',
    type: 'text',
    value: '',
  },
  roofType: {
    label: 'Roof Type',
    type: 'text',
    value: '',
  },
  otherRoofType: {
    label: 'Other Roof Type',
    type: 'text',
    value: '',
  },
  otherConstructionInformation: {
    label: 'Other Construction Information',
    type: 'textarea',
    value: '',
  },
})
